import React from "react"
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {resetPassword} from "../auth-actions";
import {setNotification} from "../../notifications/notifications-actions";
import {push} from 'connected-react-router'
import {FormattedMessage, injectIntl} from "react-intl";
import Notifications from "../../notifications/components/notifications";
import {handleApiResponse} from "../../crud-actions";
import {displayErrors} from "../../form-helpers";
import {Form, Formik} from "formik";
import qs from 'query-string';
import {withRouter} from "react-router";

class ForgottenPasswordReset extends React.Component {

    constructor(params) {
        super(params);
    }

    componentWillMount() {

    }

    resetPassword = (values, form) => {
        let params = qs.parse(this.props.location.search);
        let resetValues = { user: { reset_password_token: params['reset_password_token'], ...values } };
        let promise = this.props.resetPassword(resetValues);
        handleApiResponse('AUTH','RESET_PASSWORD', promise,
            (result) => {
                this.props.push('/sign-in');
                this.props.setNotification('success', this.props.intl.formatMessage({id: 'app.auth.forgotten_password.reset.success'}));
            },
            (result) => {
                this.props.setNotification('warning', this.props.intl.formatMessage({id: 'app.auth.forgotten_password.reset.fail'}));
                let errors = result.payload.response.errors;
                form.setErrors(errors);
            },
            (error) => {
                this.props.setNotification('danger', this.props.intl.formatMessage({id: 'app.message.unknown_error'}));
                console.log(error);
            }
        ).then(() => {
            form.setSubmitting(false);
        });
    };

    render() {
        return (
            <div className='container'>
                <div className='row'>
                    <div className='col-sm-6 col-lg-4 m-auto pt-5'>
                        <Notifications/>
                        <FormattedMessage id='app.auth.forgotten_password.title'>{(txt) => (<h1>{txt}</h1>)}</FormattedMessage>
                        <Formik
                            initialValues={{ password: '', password_confirmation: '' }}
                            onSubmit={this.resetPassword}
                            render={props => (
                            <Form>
                                { displayErrors(props.errors, 'base') }
                                { displayErrors(props.errors, 'reset_password_token',{ name: 'Odkaz pre zmenu hesla'}) }
                                <div className='form-group'>
                                    <FormattedMessage id='app.auth.sign_in.attribute.password'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                                    <input value={props.values.password} id='password' type='password' className='form-control' onChange={props.handleChange} onBlur={props.handleBlur}/>
                                    { displayErrors(props.errors, 'password')}
                                </div>
                                <div className='form-group'>
                                    <FormattedMessage id='app.auth.sign_in.attribute.password_confirmation'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                                    <input value={props.values.password_confirmation} id='password_confirmation' type='password' className='form-control' onChange={props.handleChange} onBlur={props.handleBlur}/>
                                    { displayErrors(props.errors, 'password_confirmation')}
                                </div>
                                <hr/>
                                <div className=''>
                                    <button type='submit' className='btn btn-gasnet-green' disabled={props.isSubmitting}>{this.props.intl.formatMessage({id: 'app.auth.forgotten_password.action.reset_password'})}</button>
                                </div>
                            </Form>
                        )}>
                        </Formik>
                    </div>
                </div>    
            </div>
        );
    }
}


function mapStateToProps(state,ownProps) {
    return {
        location: ownProps.location,
        auth: state.auth,
        destination: ownProps.destination
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        setNotification: setNotification,
        push: push,
        resetPassword: resetPassword
    }, dispatch);
}

export default withRouter(injectIntl(connect(mapStateToProps, matchDispatchToProps)(ForgottenPasswordReset)));
